<p-toast></p-toast>

<p-sidebar [(visible)]="showTransactionsSidebar"
           position="right"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'60em'}">
    <ng-template pTemplate="header">Schedule Payout</ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <!--Menu-->

    <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

    <div *ngIf="!loading" class="transaction-body">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 260px)'}"
                       [styleClass]="'app-scrollpanel'">

            <div class="transaction-info-body" *ngIf="activeTab === transactionDetailsTab.ScheduleSettings">

                <p class="refund-description" style="padding-top: 5px;">Please select payout request to be extracted and emailed to Cebuana lhuillier</p>

                <div *ngFor="let holiday of scheduleSettings" class="flex flex-row" style="margin-left: 0px; margin-top: 30px;">
                    <div class="flex flex-row" style="height: 70px;">
                        <div class="driver-center-holiday-hours-margin-calendar">
                            <div>Created At</div>
                            <p-calendar [inputStyle]="{'width':'100px'}" [(ngModel)]="holiday.CreatedAt" [disabled]="true" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
                        </div>
                        <div class="driver-center-holiday-hours-margin-calendar">
                            <div>StartTime At</div>
                            <p-calendar [inputStyle]="{'width':'100px'}" [(ngModel)]="holiday.StartTimeAt" [disabled]="true" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
                        </div>
                        <div class="driver-center-holiday-hours-margin-calendar">
                            <div>EndTime At</div>
                            <p-calendar [inputStyle]="{'width':'100px'}" [(ngModel)]="holiday.EndTimeAt" [disabled]="true" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
                        </div>
                        <div class="driver-center-holiday-hours-margin-calendar">
                            <div>Schedule At</div>
                            <p-calendar [inputStyle]="{'width':'100px'}" [(ngModel)]="holiday.ScheduleAt" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
                        </div>
                        <div class="driver-center-holiday-hours-margin-plus">
                            <div style="margin-left: 10px;margin-top:20px;">
                                <button pButton pRipple
                                        type="button"
                                        icon="pi pi-times"
                                        (click)="removeSettings(holiday)"
                                        class="p-button-rounded p-button-text"></button></div>
                        </div>
                    </div>
                </div>

                <div style="margin-top: 5px; margin-left: 20px;">
                    <button pButton pRipple type="button" label="Add" class="p-button-success" (click)="addSchedulerSettings()"></button>
                </div>

                <!--Modal window-->
                <p-dialog header="Payout Transaction Scheduler Settings"
                          [(visible)]="showConfirmDialog"
                          [modal]="true"
                          [style]="{width: '450px', height: '270px'}"
                          [draggable]="false"
                          [resizable]="false">
                    <div class="m-0 refund-body">
                        <p class="refund-title">Update Scheduler Settings</p>
                        <p class="refund-description">Are you sure you want to update your scheduler settings?</p>
                    </div>
                    <ng-template pTemplate="footer">
                        <div class="flex justify-content-end">
                            <div>
                                <button pButton pRipple type="button"
                                        label="Cancel"
                                        (click)="showConfirmDialog = false"
                                        class="p-button-text btn-cancel"></button>
                            </div>
                            <div>
                                <button pButton pRipple type="button"
                                        label="Save"
                                        (click)="saveSettings()"
                                        class="p-button-danger btn-refund"></button>
                            </div>
                        </div>
                    </ng-template>
                </p-dialog>

            </div>
        </p-scrollPanel>

        <hr class="driver-line" style="margin-left: -1rem; margin-right: -1rem;" />

        <div class="flex justify-content-end">
            <div>
                <button pButton pRipple type="button" label="Save" class="p-button btn-driver-edit" (click)="showConfirmDialog = true"></button>
            </div>
        </div>
    </div>

</p-sidebar>